
import React from "react";
import Fonts from "../../../../Config/Fonts";
import Icons from "../../../../Config/Images";
import Colors from "../../../../theme/Colors";
import { userStatus } from '../../../../Constants/AppConstants';

const ManufacturesTableBody = ({
  manufacturesData,
  onViewManufacturesDetails,
  handleShowDeleteModal,
  onEditManufacturesDetails,
}) => {
  return (
    <tbody>
      {manufacturesData?.map((manufacture, index) => (
        <tr key={index}>
        <td style={tableDataInputStyle}>{index + 1}</td>
          <td style={tableDataInputStyle}>
            {manufacture?.user_shop_name}
          </td>
          <td style={tableDataInputStyle}>{manufacture?.user_state || "-"}</td>
          <td style={tableDataInputStyle}>{manufacture?.user_city || "-"}</td>
          <td style={tableDataInputStyle} >
          {manufacture?.user_manufactures_category || '-'}
          </td>

          <td style={tableDataInputStyle} >
          {manufacture?.user_manufactures_last_order_date || '-'}
          </td>
          <td style={tableDataInputStyle} >
          {manufacture?.user_manufactures_total_order_value || '-'}
          </td>
          <td style={tableDataInputStyle} >
          {manufacture?.user_manufactures_total_products || '-'}
          </td>
          <td style={tableDataInputStyle} >
          {manufacture?.user_manufactures_out_of_stock || '-'}
          </td>
          <td style={tableDataInputStyle} >
          <div
              style={{
                color:
                  userStatus[manufacture?.user_status_id]?.color || "#e0e0e0",
                padding: "5px 10px",
                borderRadius: "4px",

                textAlign: "center",
              }}
            >
              {userStatus[manufacture?.user_status_id]?.label || "Unknown"}
            </div>
          </td>
          <td style={tableDataInputStyle} >
          {manufacture?.user_manufactures_rating || '-'}
          </td>
          <td style={tableDataInputStyle} >
          {manufacture?.user_manufactures_total_order_count || '-'}
          </td>
          <td align="center" style={tableDataInputStyle}>
            <img
              src={Icons.viewIcon}
              style={{ height: "20px", width: "20px", cursor: "pointer", marginLeft: "10px", }}
              onClick={() => onViewManufacturesDetails(manufacture)}
              alt="Preview Icon"
            />
            <img
              src={Icons.editIcon}
              style={{
                height: "20px",
                width: "20px",
                cursor: "pointer",
                marginLeft: "15px",
              }}
              onClick={() => onEditManufacturesDetails(manufacture)}
              alt="Edit Icon"
            />
            <img
              src={Icons.trashIcon}
              style={{
                height: "20px",
                width: "20px",
                cursor: "pointer",
                marginLeft: "15px",
                marginRight: '15px'
              }}
              onClick={() => handleShowDeleteModal(manufacture?.user_id)}
              alt="Delete Icon"
            />
          </td>
        </tr>
      ))}
    </tbody>
  );
};


const tableDataInputStyle = {
  fontSize: 12,
  fontWeight: 500,
  fontFamily: Fonts.Poppins,
  color: Colors.black,
  textAlign: "center",
  padding: "8px 10px",
  border: "1px solid #E6E6E6",
};

export default ManufacturesTableBody;
